import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
// import LockIcon from '@material-ui/icons/LockOutline';
import ResetPassView from "./ResetPass";

import { Notification, useTranslate, useNotify, useLogin } from "react-admin";

const styles = theme => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "flex-start",
    background: "url(https://source.unsplash.com/1600x900/?CAR)", 
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  card: {
    minWidth: 300,
    marginTop: "6em"
  },
  avatar: {
    margin: "1em",
    display: "flex",
    justifyContent: "center"
  },
  icon: {
    backgroundColor: theme.palette.secondary.main
  },
  hint: {
    marginTop: "1em",
    display: "flex",
    justifyContent: "center",
    color: theme.palette.grey[500]
  },
  form: {
    padding: "0 1em 1em 1em"
  },
  input: {
    marginTop: "1em"
  },
  actions: {
    padding: "0 1em 1em 1em"
  }
});



function Login(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const login = useLogin();
  const notify = useNotify();
  const translate = useTranslate();
  const forgotPassClicked = () => {
    setShowForgot(true);
  };
  const submit = e => {
    e.preventDefault();

    login({ username, password }).catch((e) => {
      console.log(e)

      notify("Invalid email or password")
    }
    );
  };
  const { classes, isLoading } = props;
  console.log(props);

  return (
    <div className={ classes.main }>
      <Card className={ classes.card }>
        <div className={ classes.avatar }>
          <Avatar className={ classes.icon }>{/* <LockIcon /> */ }</Avatar>
        </div>
        <form onSubmit={ submit }>
          <div className={ classes.form }>
            <div className={ classes.input }>
              <TextField
                name="username"
                fullWidth
                label={ translate("ra.auth.username") }
                disabled={ isLoading }
                onChange={ e => setUsername(e.target.value) }
              />
            </div>
            <div className={ classes.input }>
              <TextField
                name="password"
                fullWidth
                label={ translate("ra.auth.password") }
                type="password"
                disabled={ isLoading }
                onChange={ e => setPassword(e.target.value) }
              />
            </div>
            <br />
            <div className={ classes.input }>
              <span style={ { cursor: "pointer", fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', } } onClick={ forgotPassClicked }>
                Forgot Password?
              </span>
              { showForgot && <ResetPassView /> }
            </div>
          </div>

          <CardActions className={ classes.actions }>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={ isLoading }
              className={ classes.button }
              fullWidth
            >
              { isLoading && <CircularProgress size={ 25 } thickness={ 2 } /> }
              { translate("ra.auth.sign_in") }
            </Button>
          </CardActions>
        </form>
      </Card>
      <Notification />
    </div>
  );
}

// Login.propTypes = {
//   ...propTypes,
//   authProvider: PropTypes.func,
//   classes: PropTypes.object,
//   previousRoute: PropTypes.string,
//   translate: PropTypes.func.isRequired,
//   userLogin: PropTypes.func.isRequired
// };

// const mapStateToProps = state => ({ isLoading: state.admin.loading > 0 });

// const enhance = compose(
//   translate,
//   useForm({
//     form: "signIn",
//     validate: (values, props) => {
//       const errors = {};
//       const { translate } = props;
//       if (!values.username) {
//         errors.username = translate("ra.validation.required");
//       }
//       if (!values.password) {
//         errors.password = translate("ra.validation.required");
//       }
//       return errors;
//     }
//   }),
//   connect(mapStateToProps, { userLogin }),
//   withStyles(styles)
// );

export default withStyles(styles)(Login);
